<template>
    <div class="m-container py-10">
        <div class="m-row" style="justify-content: center;">
            <div class="m-col m-col-12 m-col-md-8 legal-content">
                <h1 class="titel-h1 font-weight-bold mb-6">
                    Datenschutzerklärung
                </h1>
                <h2>1. Datenschutz auf einen Blick</h2>
                <h3>Allgemeine Hinweise</h3>
                <p>
                    Die folgenden Hinweise geben einen einfachen Überblick
                    darüber, was mit Ihren personenbezogenen Daten passiert,
                    wenn Sie unsere Website besuchen. Personenbezogene Daten
                    sind alle Daten, mit denen Sie persönlich identifiziert
                    werden können. Ausführliche Informationen zum Thema
                    Datenschutz entnehmen Sie unserer unter diesem Text
                    aufgeführten Datenschutzerklärung.
                </p>
                <h3>Datenerfassung auf unserer Website</h3>
                <p>
                    <strong
                        >Wer ist verantwortlich für die Datenerfassung auf
                        dieser Website?</strong
                    >
                </p>
                <p>
                    Die Datenverarbeitung auf dieser Website erfolgt durch den
                    Websitebetreiber. Dessen Kontaktdaten können Sie dem
                    Impressum dieser Website entnehmen.
                </p>
                <p><strong>Wie erfassen wir Ihre Daten?</strong></p>
                <p>
                    Ihre Daten werden zum einen dadurch erhoben, dass Sie uns
                    diese mitteilen. Hierbei kann es sich z.B. um Daten handeln,
                    die Sie in ein Kontaktformular eingeben.
                </p>
                <p>
                    Andere Daten werden automatisch beim Besuch der Website
                    durch unsere IT-Systeme erfasst. Das sind vor allem
                    technische Daten (z.B. Internetbrowser, Betriebssystem oder
                    Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten
                    erfolgt automatisch, sobald Sie unsere Website betreten.
                </p>
                <p><strong>Wofür nutzen wir Ihre Daten?</strong></p>
                <p>
                    Ein Teil der Daten wird erhoben, um eine fehlerfreie
                    Bereitstellung der Website zu gewährleisten. Andere Daten
                    können zur Analyse Ihres Nutzerverhaltens verwendet werden.
                </p>
                <p>
                    <strong
                        >Welche Rechte haben Sie bezüglich Ihrer Daten?</strong
                    >
                </p>
                <p>
                    Sie haben jederzeit das Recht unentgeltlich Auskunft über
                    Herkunft, Empfänger und Zweck Ihrer gespeicherten
                    personenbezogenen Daten zu erhalten. Sie haben außerdem ein
                    Recht, die Berichtigung, Sperrung oder Löschung dieser Daten
                    zu verlangen. Hierzu sowie zu weiteren Fragen zum Thema
                    Datenschutz können Sie sich jederzeit unter der im Impressum
                    angegebenen Adresse an uns wenden. Des Weiteren steht Ihnen
                    ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
                </p>
                <h3>Analyse-Tools und Tools von Drittanbietern</h3>
                <p>
                    Beim Besuch unserer Website kann Ihr Surf-Verhalten
                    statistisch ausgewertet werden. Das geschieht vor allem mit
                    Cookies und mit sogenannten Analyseprogrammen. Die Analyse
                    Ihres Surf-Verhaltens erfolgt in der Regel anonym; das
                    Surf-Verhalten kann nicht zu Ihnen zurückverfolgt werden.
                    Sie können dieser Analyse widersprechen oder sie durch die
                    Nichtbenutzung bestimmter Tools verhindern. Detaillierte
                    Informationen dazu finden Sie in der folgenden
                    Datenschutzerklärung.
                </p>
                <p>
                    Sie können dieser Analyse widersprechen. Über die
                    Widerspruchsmöglichkeiten werden wir Sie in dieser
                    Datenschutzerklärung informieren.
                </p>
                <h2>2. Allgemeine Hinweise und Pflichtinformationen</h2>
                <h3>Datenschutz</h3>
                <p>
                    Die Betreiber dieser Seiten nehmen den Schutz Ihrer
                    persönlichen Daten sehr ernst. Wir behandeln Ihre
                    personenbezogenen Daten vertraulich und entsprechend der
                    gesetzlichen Datenschutzvorschriften sowie dieser
                    Datenschutzerklärung.
                </p>
                <p>
                    Wenn Sie diese Website benutzen, werden verschiedene
                    personenbezogene Daten erhoben. Personenbezogene Daten sind
                    Daten, mit denen Sie persönlich identifiziert werden können.
                    Die vorliegende Datenschutzerklärung erläutert, welche Daten
                    wir erheben und wofür wir sie nutzen. Sie erläutert auch,
                    wie und zu welchem Zweck das geschieht.
                </p>
                <p>
                    Wir weisen darauf hin, dass die Datenübertragung im Internet
                    (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken
                    aufweisen kann. Ein lückenloser Schutz der Daten vor dem
                    Zugriff durch Dritte ist nicht möglich.
                </p>
                <h3>Hinweis zur verantwortlichen Stelle</h3>
                <p>
                    Die verantwortliche Stelle für die Datenverarbeitung auf
                    dieser Website ist:
                </p>
                <p>
                    webdelin.com Webdesign &amp; Webentwicklung<br /><br />
                    4 Rue de Heidaecker<br />
                    57510 Puttelange aux Lacs<br />
                    info@moebix.de
                    <br />
                </p>

                <p>
                    Verantwortliche Stelle ist die natürliche oder juristische
                    Person, die allein oder gemeinsam mit anderen über die
                    Zwecke und Mittel der Verarbeitung von personenbezogenen
                    Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
                </p>
                <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
                <p>
                    Viele Datenverarbeitungsvorgänge sind nur mit Ihrer
                    ausdrücklichen Einwilligung möglich. Sie können eine bereits
                    erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine
                    formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit
                    der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom
                    Widerruf unberührt.
                </p>
                <h3>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>
                <p>
                    Im Falle datenschutzrechtlicher Verstöße steht dem
                    Betroffenen ein Beschwerderecht bei der zuständigen
                    Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde in
                    datenschutzrechtlichen Fragen ist der
                    Landesdatenschutzbeauftragte des Bundeslandes, in dem unser
                    Unternehmen seinen Sitz hat. Eine Liste der
                    Datenschutzbeauftragten sowie deren Kontaktdaten können
                    folgendem Link entnommen werden:
                    <a
                        href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html"
                        target="_blank"
                        >https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html</a
                    >.
                </p>
                <h3>Recht auf Datenübertragbarkeit</h3>
                <p>
                    Sie haben das Recht, Daten, die wir auf Grundlage Ihrer
                    Einwilligung oder in Erfüllung eines Vertrags automatisiert
                    verarbeiten, an sich oder an einen Dritten in einem
                    gängigen, maschinenlesbaren Format aushändigen zu lassen.
                    Sofern Sie die direkte Übertragung der Daten an einen
                    anderen Verantwortlichen verlangen, erfolgt dies nur, soweit
                    es technisch machbar ist.
                </p>
                <h3>SSL- bzw. TLS-Verschlüsselung</h3>
                <p>
                    Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
                    Übertragung vertraulicher Inhalte, wie zum Beispiel
                    Bestellungen oder Anfragen, die Sie an uns als
                    Seitenbetreiber senden, eine SSL-bzw. TLS-Verschlüsselung.
                    Eine verschlüsselte Verbindung erkennen Sie daran, dass die
                    Adresszeile des Browsers von “http://” auf “https://”
                    wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
                </p>
                <p>
                    Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können
                    die Daten, die Sie an uns übermitteln, nicht von Dritten
                    mitgelesen werden.
                </p>
                <h3>Verschlüsselter Zahlungsverkehr auf dieser Website</h3>
                <p>
                    Besteht nach dem Abschluss eines kostenpflichtigen Vertrags
                    eine Verpflichtung, uns Ihre Zahlungsdaten (z.B. Kontonummer
                    bei Einzugsermächtigung) zu übermitteln, werden diese Daten
                    zur Zahlungsabwicklung benötigt.
                </p>
                <p>
                    Der Zahlungsverkehr über die gängigen Zahlungsmittel
                    (Visa/MasterCard, Lastschriftverfahren) erfolgt
                    ausschließlich über eine verschlüsselte SSL- bzw.
                    TLS-Verbindung. Eine verschlüsselte Verbindung erkennen Sie
                    daran, dass die Adresszeile des Browsers von "http://" auf
                    "https://" wechselt und an dem Schloss-Symbol in Ihrer
                    Browserzeile.
                </p>
                <p>
                    Bei verschlüsselter Kommunikation können Ihre Zahlungsdaten,
                    die Sie an uns übermitteln, nicht von Dritten mitgelesen
                    werden.
                </p>
                <h3>Auskunft, Sperrung, Löschung</h3>
                <p>
                    Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen
                    jederzeit das Recht auf unentgeltliche Auskunft über Ihre
                    gespeicherten personenbezogenen Daten, deren Herkunft und
                    Empfänger und den Zweck der Datenverarbeitung und ggf. ein
                    Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.
                    Hierzu sowie zu weiteren Fragen zum Thema personenbezogene
                    Daten können Sie sich jederzeit unter der im Impressum
                    angegebenen Adresse an uns wenden.
                </p>
                <h3>Widerspruch gegen Werbe-Mails</h3>
                <p>
                    Der Nutzung von im Rahmen der Impressumspflicht
                    veröffentlichten Kontaktdaten zur Übersendung von nicht
                    ausdrücklich angeforderter Werbung und
                    Informationsmaterialien wird hiermit widersprochen. Die
                    Betreiber der Seiten behalten sich ausdrücklich rechtliche
                    Schritte im Falle der unverlangten Zusendung von
                    Werbeinformationen, etwa durch Spam-E-Mails, vor.
                </p>
                <h2>3. Datenerfassung auf unserer Website</h2>
                <h3>Cookies</h3>
                <p>
                    Die Internetseiten verwenden teilweise so genannte Cookies.
                    Cookies richten auf Ihrem Rechner keinen Schaden an und
                    enthalten keine Viren. Cookies dienen dazu, unser Angebot
                    nutzerfreundlicher, effektiver und sicherer zu machen.
                    Cookies sind kleine Textdateien, die auf Ihrem Rechner
                    abgelegt werden und die Ihr Browser speichert.
                </p>
                <p>
                    Die meisten der von uns verwendeten Cookies sind so genannte
                    “Session-Cookies”. Sie werden nach Ende Ihres Besuchs
                    automatisch gelöscht. Andere Cookies bleiben auf Ihrem
                    Endgerät gespeichert bis Sie diese löschen. Diese Cookies
                    ermöglichen es uns, Ihren Browser beim nächsten Besuch
                    wiederzuerkennen.
                </p>
                <p>
                    Sie können Ihren Browser so einstellen, dass Sie über das
                    Setzen von Cookies informiert werden und Cookies nur im
                    Einzelfall erlauben, die Annahme von Cookies für bestimmte
                    Fälle oder generell ausschließen sowie das automatische
                    Löschen der Cookies beim Schließen des Browser aktivieren.
                    Bei der Deaktivierung von Cookies kann die Funktionalität
                    dieser Website eingeschränkt sein.
                </p>
                <p>
                    Cookies, die zur Durchführung des elektronischen
                    Kommunikationsvorgangs oder zur Bereitstellung bestimmter,
                    von Ihnen erwünschter Funktionen (z.B. Warenkorbfunktion)
                    erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1
                    lit. f DSGVO gespeichert. Der Websitebetreiber hat ein
                    berechtigtes Interesse an der Speicherung von Cookies zur
                    technisch fehlerfreien und optimierten Bereitstellung seiner
                    Dienste. Soweit andere Cookies (z.B. Cookies zur Analyse
                    Ihres Surfverhaltens) gespeichert werden, werden diese in
                    dieser Datenschutzerklärung gesondert behandelt.
                </p>
                <h3>Server-Log-Dateien</h3>
                <p>
                    Der Provider der Seiten erhebt und speichert automatisch
                    Informationen in so genannten Server-Log-Dateien, die Ihr
                    Browser automatisch an uns übermittelt. Dies sind:
                </p>
                <ul>
                    <li>Browsertyp und Browserversion</li>
                    <li>verwendetes Betriebssystem</li>
                    <li>Referrer URL</li>
                    <li>Hostname des zugreifenden Rechners</li>
                    <li>Uhrzeit der Serveranfrage</li>
                    <li>IP-Adresse</li>
                </ul>
                <p>
                    Eine Zusammenführung dieser Daten mit anderen Datenquellen
                    wird nicht vorgenommen.
                </p>
                <p>
                    Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. b
                    DSGVO, der die Verarbeitung von Daten zur Erfüllung eines
                    Vertrags oder vorvertraglicher Maßnahmen gestattet.
                </p>
                <h3>Kontaktformular</h3>
                <p>
                    Wenn Sie uns per Kontaktformular Anfragen zukommen lassen,
                    werden Ihre Angaben aus dem Anfrageformular inklusive der
                    von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung
                    der Anfrage und für den Fall von Anschlussfragen bei uns
                    gespeichert. Diese Daten geben wir nicht ohne Ihre
                    Einwilligung weiter.
                </p>
                <p>
                    Die Verarbeitung der in das Kontaktformular eingegebenen
                    Daten erfolgt somit ausschließlich auf Grundlage Ihrer
                    Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie können diese
                    Einwilligung jederzeit widerrufen. Dazu reicht eine formlose
                    Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum
                    Widerruf erfolgten Datenverarbeitungsvorgänge bleibt vom
                    Widerruf unberührt.
                </p>
                <p>
                    Die von Ihnen im Kontaktformular eingegebenen Daten
                    verbleiben bei uns, bis Sie uns zur Löschung auffordern,
                    Ihre Einwilligung zur Speicherung widerrufen oder der Zweck
                    für die Datenspeicherung entfällt (z.B. nach abgeschlossener
                    Bearbeitung Ihrer Anfrage). Zwingende gesetzliche
                    Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben
                    unberührt.
                </p>
                <h3>Registrierung auf dieser Website</h3>
                <p>
                    Sie können sich auf unserer Website registrieren, um
                    zusätzliche Funktionen auf der Seite zu nutzen. Die dazu
                    eingegebenen Daten verwenden wir nur zum Zwecke der Nutzung
                    des jeweiligen Angebotes oder Dienstes, für den Sie sich
                    registriert haben. Die bei der Registrierung abgefragten
                    Pflichtangaben müssen vollständig angegeben werden.
                    Anderenfalls werden wir die Registrierung ablehnen.
                </p>
                <p>
                    Für wichtige Änderungen etwa beim Angebotsumfang oder bei
                    technisch notwendigen Änderungen nutzen wir die bei der
                    Registrierung angegebene E-Mail-Adresse, um Sie auf diesem
                    Wege zu informieren.
                </p>
                <p>
                    Die Verarbeitung der bei der Registrierung eingegebenen
                    Daten erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs.
                    1 lit. a DSGVO). Sie können eine von Ihnen erteilte
                    Einwilligung jederzeit widerrufen. Dazu reicht eine formlose
                    Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bereits
                    erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
                </p>
                <p>
                    Die bei der Registrierung erfassten Daten werden von uns
                    gespeichert, solange Sie auf unserer Website registriert
                    sind und werden anschließend gelöscht. Gesetzliche
                    Aufbewahrungsfristen bleiben unberührt.
                </p>
                <h3>Registrierung mit Facebook Connect</h3>
                <p>
                    Statt einer direkten Registrierung auf unserer Website
                    können Sie sich mit Facebook Connect registrieren. Anbieter
                    dieses Dienstes ist die Facebook Ireland Limited, 4 Grand
                    Canal Square, Dublin 2, Irland.
                </p>
                <p>
                    Wenn Sie sich für die Registrierung mit Facebook Connect
                    entscheiden und auf den “Login with Facebook”- / “Connect
                    with Facebook”-Button klicken, werden Sie automatisch auf
                    die Plattform von Facebook weitergeleitet. Dort können Sie
                    sich mit Ihren Nutzungsdaten anmelden. Dadurch wird Ihr
                    Facebook-Profil mit unserer Website bzw. unseren Diensten
                    verknüpft. Durch diese Verknüpfung erhalten wir Zugriff auf
                    Ihre bei Facebook hinterlegten Daten. Dies sind vor allem:
                </p>
                <ul>
                    <li>Facebook-Name</li>
                    <li>Facebook-Profil- und Titelbild</li>
                    <li>Facebook-Titelbild</li>
                    <li>bei Facebook hinterlegte E-Mail-Adresse</li>
                    <li>Facebook-ID</li>
                    <li>Facebook-Freundeslisten</li>
                    <li>Facebook Likes (“Gefällt-mir”-Angaben)</li>
                    <li>Geburtstag</li>
                    <li>Geschlecht</li>
                    <li>Land</li>
                    <li>Sprache</li>
                </ul>
                <p>
                    Diese Daten werden zur Einrichtung, Bereitstellung und
                    Personalisierung Ihres Accounts genutzt.
                </p>
                <p>
                    Weitere Informationen finden Sie in den
                    Facebook-Nutzungsbedingungen und den
                    Facebook-Datenschutzbestimmungen. Diese finden Sie unter:
                    <a
                        href="https://de-de.facebook.com/about/privacy/"
                        target="_blank"
                        >https://de-de.facebook.com/about/privacy/</a
                    >
                    und
                    <a
                        href="https://www.facebook.com/legal/terms/"
                        target="_blank"
                        >https://www.facebook.com/legal/terms/</a
                    >.
                </p>
                <h3>Verarbeiten von Daten (Kunden- und Vertragsdaten)</h3>
                <p>
                    Wir erheben, verarbeiten und nutzen personenbezogene Daten
                    nur, soweit sie für die Begründung, inhaltliche
                    Ausgestaltung oder Änderung des Rechtsverhältnisses
                    erforderlich sind (Bestandsdaten). Dies erfolgt auf
                    Grundlage von Art. 6 Abs. 1 lit. b DSGVO, der die
                    Verarbeitung von Daten zur Erfüllung eines Vertrags oder
                    vorvertraglicher Maßnahmen gestattet. Personenbezogene Daten
                    über die Inanspruchnahme unserer Internetseiten
                    (Nutzungsdaten) erheben, verarbeiten und nutzen wir nur,
                    soweit dies erforderlich ist, um dem Nutzer die
                    Inanspruchnahme des Dienstes zu ermöglichen oder
                    abzurechnen.
                </p>
                <p>
                    Die erhobenen Kundendaten werden nach Abschluss des Auftrags
                    oder Beendigung der Geschäftsbeziehung gelöscht. Gesetzliche
                    Aufbewahrungsfristen bleiben unberührt.
                </p>
                <h3>
                    Datenübermittlung bei Vertragsschluss für Online-Shops,
                    Händler und Warenversand
                </h3>
                <p>
                    Wir übermitteln personenbezogene Daten an Dritte nur dann,
                    wenn dies im Rahmen der Vertragsabwicklung notwendig ist,
                    etwa an die mit der Lieferung der Ware betrauten Unternehmen
                    oder das mit der Zahlungsabwicklung beauftragte
                    Kreditinstitut. Eine weitergehende Übermittlung der Daten
                    erfolgt nicht bzw. nur dann, wenn Sie der Übermittlung
                    ausdrücklich zugestimmt haben. Eine Weitergabe Ihrer Daten
                    an Dritte ohne ausdrückliche Einwilligung, etwa zu Zwecken
                    der Werbung, erfolgt nicht.
                </p>
                <p>
                    Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. b
                    DSGVO, der die Verarbeitung von Daten zur Erfüllung eines
                    Vertrags oder vorvertraglicher Maßnahmen gestattet.
                </p>
                <h3>
                    Datenübermittlung bei Vertragsschluss für Dienstleistungen
                    und digitale Inhalte
                </h3>
                <p>
                    Wir übermitteln personenbezogene Daten an Dritte nur dann,
                    wenn dies im Rahmen der Vertragsabwicklung notwendig ist,
                    etwa an das mit der Zahlungsabwicklung beauftragte
                    Kreditinstitut.
                </p>
                <p>
                    Eine weitergehende Übermittlung der Daten erfolgt nicht bzw.
                    nur dann, wenn Sie der Übermittlung ausdrücklich zugestimmt
                    haben. Eine Weitergabe Ihrer Daten an Dritte ohne
                    ausdrückliche Einwilligung, etwa zu Zwecken der Werbung,
                    erfolgt nicht.
                </p>
                <p>
                    Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. b
                    DSGVO, der die Verarbeitung von Daten zur Erfüllung eines
                    Vertrags oder vorvertraglicher Maßnahmen gestattet.
                </p>
                <h2>4. Soziale Medien</h2>
                <h3>
                    Inhalte teilen über Plugins (Facebook, Google+1, Twitter &
                    Co.)
                </h3>
                <p>
                    Die Inhalte auf unseren Seiten können datenschutzkonform in
                    sozialen Netzwerken wie Facebook, Twitter oder Google+
                    geteilt werden. Diese Seite nutzt dafür das
                    <a
                        href="https://www.e-recht24.de/erecht24-safe-sharing.html#datenschutz"
                        target="_blank"
                        >eRecht24 Safe Sharing Tool</a
                    >. Dieses Tool stellt den direkten Kontakt zwischen den
                    Netzwerken und Nutzern erst dann her, wenn der Nutzer aktiv
                    auf einen dieser Button klickt.
                </p>
                <p>
                    Eine automatische Übertragung von Nutzerdaten an die
                    Betreiber dieser Plattformen erfolgt durch dieses Tool
                    nicht. Ist der Nutzer bei einem der sozialen Netzwerke
                    angemeldet, erscheint bei der Nutzung der Social-Buttons von
                    Facebook, Google+1, Twitter & Co. ein Informations-Fenster,
                    in dem der Nutzer den Text vor dem Absenden bestätigen kann.
                </p>
                <p>
                    Unsere Nutzer können die Inhalte dieser Seite
                    datenschutzkonform in sozialen Netzwerken teilen, ohne dass
                    komplette Surf-Profile durch die Betreiber der Netzwerke
                    erstellt werden.
                </p>
                <h3>Facebook-Plugins (Like & Share-Button)</h3>
                <p>
                    Auf unseren Seiten sind Plugins des sozialen Netzwerks
                    Facebook, Anbieter Facebook Inc., 1 Hacker Way, Menlo Park,
                    California 94025, USA, integriert. Die Facebook-Plugins
                    erkennen Sie an dem Facebook-Logo oder dem "Like-Button"
                    ("Gefällt mir") auf unserer Seite. Eine Übersicht über die
                    Facebook-Plugins finden Sie hier:
                    <a
                        href="https://developers.facebook.com/docs/plugins/"
                        target="_blank"
                        >https://developers.facebook.com/docs/plugins/</a
                    >.
                </p>
                <p>
                    Wenn Sie unsere Seiten besuchen, wird über das Plugin eine
                    direkte Verbindung zwischen Ihrem Browser und dem
                    Facebook-Server hergestellt. Facebook erhält dadurch die
                    Information, dass Sie mit Ihrer IP-Adresse unsere Seite
                    besucht haben. Wenn Sie den Facebook "Like-Button" anklicken
                    während Sie in Ihrem Facebook-Account eingeloggt sind,
                    können Sie die Inhalte unserer Seiten auf Ihrem
                    Facebook-Profil verlinken. Dadurch kann Facebook den Besuch
                    unserer Seiten Ihrem Benutzerkonto zuordnen. Wir weisen
                    darauf hin, dass wir als Anbieter der Seiten keine Kenntnis
                    vom Inhalt der übermittelten Daten sowie deren Nutzung durch
                    Facebook erhalten. Weitere Informationen hierzu finden Sie
                    in der Datenschutzerklärung von Facebook unter:
                    <a
                        href="https://de-de.facebook.com/policy.php"
                        target="_blank"
                        >https://de-de.facebook.com/policy.php</a
                    >.
                </p>
                <p>
                    Wenn Sie nicht wünschen, dass Facebook den Besuch unserer
                    Seiten Ihrem Facebook-Nutzerkonto zuordnen kann, loggen Sie
                    sich bitte aus Ihrem Facebook-Benutzerkonto aus.
                </p>
                <h3>Twitter Plugin</h3>
                <p>
                    Auf unseren Seiten sind Funktionen des Dienstes Twitter
                    eingebunden. Diese Funktionen werden angeboten durch die
                    Twitter Inc., 1355 Market Street, Suite 900, San Francisco,
                    CA 94103, USA. Durch das Benutzen von Twitter und der
                    Funktion "Re-Tweet" werden die von Ihnen besuchten Websites
                    mit Ihrem Twitter-Account verknüpft und anderen Nutzern
                    bekannt gegeben. Dabei werden auch Daten an Twitter
                    übertragen. Wir weisen darauf hin, dass wir als Anbieter der
                    Seiten keine Kenntnis vom Inhalt der übermittelten Daten
                    sowie deren Nutzung durch Twitter erhalten. Weitere
                    Informationen hierzu finden Sie in der Datenschutzerklärung
                    von Twitter unter:
                    <a href="https://twitter.com/privacy" target="_blank"
                        >https://twitter.com/privacy</a
                    >.
                </p>
                <p>
                    Ihre Datenschutzeinstellungen bei Twitter können Sie in den
                    Konto-Einstellungen unter
                    <a
                        href="https://twitter.com/account/settings"
                        target="_blank"
                        >https://twitter.com/account/settings</a
                    >
                    ändern.
                </p>
                <h3>Google+ Plugin</h3>
                <p>
                    Unsere Seiten nutzen Funktionen von Google+. Anbieter ist
                    die Google Inc., 1600 Amphitheatre Parkway, Mountain View,
                    CA 94043, USA.
                </p>
                <p>
                    Erfassung und Weitergabe von Informationen: Mithilfe der
                    Google+-Schaltfläche können Sie Informationen weltweit
                    veröffentlichen. Über die Google+-Schaltfläche erhalten Sie
                    und andere Nutzer personalisierte Inhalte von Google und
                    unseren Partnern. Google speichert sowohl die Information,
                    dass Sie für einen Inhalt +1 gegeben haben, als auch
                    Informationen über die Seite, die Sie beim Klicken auf +1
                    angesehen haben. Ihre +1 können als Hinweise zusammen mit
                    Ihrem Profilnamen und Ihrem Foto in Google-Diensten, wie
                    etwa in Suchergebnissen oder in Ihrem Google-Profil, oder an
                    anderen Stellen auf Websites und Anzeigen im Internet
                    eingeblendet werden.
                </p>
                <p>
                    Google zeichnet Informationen über Ihre +1-Aktivitäten auf,
                    um die Google-Dienste für Sie und andere zu verbessern. Um
                    die Google+-Schaltfläche verwenden zu können, benötigen Sie
                    ein weltweit sichtbares, öffentliches Google-Profil, das
                    zumindest den für das Profil gewählten Namen enthalten muss.
                    Dieser Name wird in allen Google-Diensten verwendet. In
                    manchen Fällen kann dieser Name auch einen anderen Namen
                    ersetzen, den Sie beim Teilen von Inhalten über Ihr
                    Google-Konto verwendet haben. Die Identität Ihres
                    Google-Profils kann Nutzern angezeigt werden, die Ihre
                    E-Mail-Adresse kennen oder über andere identifizierende
                    Informationen von Ihnen verfügen.
                </p>
                <p>
                    Verwendung der erfassten Informationen: Neben den oben
                    erläuterten Verwendungszwecken werden die von Ihnen
                    bereitgestellten Informationen gemäß den geltenden
                    Google-Datenschutzbestimmungen genutzt. Google
                    veröffentlicht möglicherweise zusammengefasste Statistiken
                    über die +1-Aktivitäten der Nutzer bzw. gibt diese an Nutzer
                    und Partner weiter, wie etwa Publisher, Inserenten oder
                    verbundene Websites.
                </p>
                <h3>Instagram Plugin</h3>
                <p>
                    Auf unseren Seiten sind Funktionen des Dienstes Instagram
                    eingebunden. Diese Funktionen werden angeboten durch die
                    Instagram Inc., 1601 Willow Road, Menlo Park, CA 94025, USA
                    integriert.
                </p>
                <p>
                    Wenn Sie in Ihrem Instagram-Account eingeloggt sind, können
                    Sie durch Anklicken des Instagram-Buttons die Inhalte
                    unserer Seiten mit Ihrem Instagram-Profil verlinken. Dadurch
                    kann Instagram den Besuch unserer Seiten Ihrem Benutzerkonto
                    zuordnen. Wir weisen darauf hin, dass wir als Anbieter der
                    Seiten keine Kenntnis vom Inhalt der übermittelten Daten
                    sowie deren Nutzung durch Instagram erhalten.
                </p>
                <p>
                    Weitere Informationen hierzu finden Sie in der
                    Datenschutzerklärung von Instagram:
                    <a
                        href="https://instagram.com/about/legal/privacy/"
                        target="_blank"
                        >https://instagram.com/about/legal/privacy/</a
                    >.
                </p>
                <h3>XING Plugin</h3>
                <p>
                    Unsere Website nutzt Funktionen des Netzwerks XING. Anbieter
                    ist die XING AG, Dammtorstraße 29-32, 20354 Hamburg,
                    Deutschland.
                </p>
                <p>
                    Bei jedem Abruf einer unserer Seiten, die Funktionen von
                    XING enthält, wird eine Verbindung zu Servern von XING
                    hergestellt. Eine Speicherung von personenbezogenen Daten
                    erfolgt dabei nach unserer Kenntnis nicht. Insbesondere
                    werden keine IP-Adressen gespeichert oder das
                    Nutzungsverhalten ausgewertet.
                </p>
                <p>
                    Weitere Information zum Datenschutz und dem XING
                    Share-Button finden Sie in der Datenschutzerklärung von XING
                    unter:
                    <a
                        href="https://www.xing.com/app/share?op=data_protection"
                        target="_blank"
                        >https://www.xing.com/app/share?op=data_protection</a
                    >.
                </p>
                <h2>5. Analyse Tools und Werbung</h2>
                <h3>Google Analytics</h3>
                <p>
                    Diese Website nutzt Funktionen des Webanalysedienstes Google
                    Analytics. Anbieter ist die Google Inc., 1600 Amphitheatre
                    Parkway, Mountain View, CA 94043, USA.
                </p>
                <p>
                    Google Analytics verwendet so genannte "Cookies". Das sind
                    Textdateien, die auf Ihrem Computer gespeichert werden und
                    die eine Analyse der Benutzung der Website durch Sie
                    ermöglichen. Die durch den Cookie erzeugten Informationen
                    über Ihre Benutzung dieser Website werden in der Regel an
                    einen Server von Google in den USA übertragen und dort
                    gespeichert.
                </p>
                <p>
                    Die Speicherung von Google-Analytics-Cookies erfolgt auf
                    Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der
                    Websitebetreiber hat ein berechtigtes Interesse an der
                    Analyse des Nutzerverhaltens, um sowohl sein Webangebot als
                    auch seine Werbung zu optimieren.
                </p>
                <p><strong>IP Anonymisierung</strong></p>
                <p>
                    Wir haben auf dieser Website die Funktion IP-Anonymisierung
                    aktiviert. Dadurch wird Ihre IP-Adresse von Google innerhalb
                    von Mitgliedstaaten der Europäischen Union oder in anderen
                    Vertragsstaaten des Abkommens über den Europäischen
                    Wirtschaftsraum vor der Übermittlung in die USA gekürzt. Nur
                    in Ausnahmefällen wird die volle IP-Adresse an einen Server
                    von Google in den USA übertragen und dort gekürzt. Im
                    Auftrag des Betreibers dieser Website wird Google diese
                    Informationen benutzen, um Ihre Nutzung der Website
                    auszuwerten, um Reports über die Websiteaktivitäten
                    zusammenzustellen und um weitere mit der Websitenutzung und
                    der Internetnutzung verbundene Dienstleistungen gegenüber
                    dem Websitebetreiber zu erbringen. Die im Rahmen von Google
                    Analytics von Ihrem Browser übermittelte IP-Adresse wird
                    nicht mit anderen Daten von Google zusammengeführt.
                </p>
                <p><strong>Browser Plugin</strong></p>
                <p>
                    Sie können die Speicherung der Cookies durch eine
                    entsprechende Einstellung Ihrer Browser-Software verhindern;
                    wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall
                    gegebenenfalls nicht sämtliche Funktionen dieser Website
                    vollumfänglich werden nutzen können. Sie können darüber
                    hinaus die Erfassung der durch den Cookie erzeugten und auf
                    Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer
                    IP-Adresse) an Google sowie die Verarbeitung dieser Daten
                    durch Google verhindern, indem Sie das unter dem folgenden
                    Link verfügbare Browser-Plugin herunterladen und
                    installieren:
                    <a
                        href="https://tools.google.com/dlpage/gaoptout?hl=de"
                        target="_blank"
                        >https://tools.google.com/dlpage/gaoptout?hl=de</a
                    >.
                </p>
                <p><strong>Widerspruch gegen Datenerfassung</strong></p>
                <p>
                    Sie können die Erfassung Ihrer Daten durch Google Analytics
                    verhindern, indem Sie auf folgenden Link klicken. Es wird
                    ein Opt-Out-Cookie gesetzt, der die Erfassung Ihrer Daten
                    bei zukünftigen Besuchen dieser Website verhindert:
                    <a href="javascript:gaOptout();"
                        >Google Analytics deaktivieren</a
                    >.
                </p>
                <p>
                    Mehr Informationen zum Umgang mit Nutzerdaten bei Google
                    Analytics finden Sie in der Datenschutzerklärung von Google:
                    <a
                        href="https://support.google.com/analytics/answer/6004245?hl=de"
                        target="_blank"
                        >https://support.google.com/analytics/answer/6004245?hl=de</a
                    >.
                </p>
                <p>
                    <strong>Demografische Merkmale bei Google Analytics</strong>
                </p>
                <p>
                    Diese Website nutzt die Funktion “demografische Merkmale”
                    von Google Analytics. Dadurch können Berichte erstellt
                    werden, die Aussagen zu Alter, Geschlecht und Interessen der
                    Seitenbesucher enthalten. Diese Daten stammen aus
                    interessenbezogener Werbung von Google sowie aus
                    Besucherdaten von Drittanbietern. Diese Daten können keiner
                    bestimmten Person zugeordnet werden. Sie können diese
                    Funktion jederzeit über die Anzeigeneinstellungen in Ihrem
                    Google-Konto deaktivieren oder die Erfassung Ihrer Daten
                    durch Google Analytics wie im Punkt “Widerspruch gegen
                    Datenerfassung” dargestellt generell untersagen.
                </p>

                <h3>Matomo (ehemals Piwik)</h3>
                <p>
                    Diese Website benutzt den Open Source Webanalysedienst
                    Matomo. Matomo verwendet so genannte "Cookies". Das sind
                    Textdateien, die auf Ihrem Computer gespeichert werden und
                    die eine Analyse der Benutzung der Website durch Sie
                    ermöglichen. Dazu werden die durch den Cookie erzeugten
                    Informationen über die Benutzung dieser Website auf unserem
                    Server gespeichert. Die IP-Adresse wird vor der Speicherung
                    anonymisiert.
                </p>
                <p>
                    Matomo-Cookies verbleiben auf Ihrem Endgerät, bis Sie sie
                    löschen.
                </p>
                <p>
                    Die Speicherung von Matomo-Cookies erfolgt auf Grundlage von
                    Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein
                    berechtigtes Interesse an der anonymisierten Analyse des
                    Nutzerverhaltens, um sowohl sein Webangebot als auch seine
                    Werbung zu optimieren.
                </p>
                <p>
                    Die durch den Cookie erzeugten Informationen über die
                    Benutzung dieser Website werden nicht an Dritte
                    weitergegeben. Sie können die Speicherung der Cookies durch
                    eine entsprechende Einstellung Ihrer Browser-Software
                    verhindern; wir weisen Sie jedoch darauf hin, dass Sie in
                    diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser
                    Website vollumfänglich werden nutzen können.
                </p>
                <p>
                    Wenn Sie mit der Speicherung und Nutzung Ihrer Daten nicht
                    einverstanden sind, können Sie die Speicherung und Nutzung
                    hier deaktivieren. In diesem Fall wird in Ihrem Browser ein
                    Opt-Out-Cookie hinterlegt, der verhindert, dass Matomo
                    Nutzungsdaten speichert. Wenn Sie Ihre Cookies löschen, hat
                    dies zur Folge, dass auch das Matomo Opt-Out-Cookie gelöscht
                    wird. Das Opt-Out muss bei einem erneuten Besuch unserer
                    Seite wieder aktiviert werden.
                </p>
                <iframe
                    style="border: 0; height: 100px; width: 100%"
                    src="https://tracker.webdelin.com/index.php?module=CoreAdminHome&action=optOut&language=de&backgroundColor=&fontColor=&fontSize=13px&fontFamily=sans-serif"
                ></iframe>
                <h3>WordPress Stats</h3>
                <p>
                    Diese Website nutzt das WordPress Tool Stats, um
                    Besucherzugriffe statistisch auszuwerten. Anbieter ist die
                    Automattic Inc., 60 29th Street #343, San Francisco, CA
                    94110-4929, USA.
                </p>
                <p>
                    WordPress Stats verwendet Cookies, die auf Ihrem Computer
                    gespeichert werden und die eine Analyse der Benutzung der
                    Website erlauben. Die durch die Cookies generierten
                    Informationen über die Benutzung unserer Website werden auf
                    Servern in den USA gespeichert. Ihre IP-Adresse wird nach
                    der Verarbeitung und vor der Speicherung anonymisiert.
                </p>
                <p>
                    “WordPress-Stats”-Cookies verbleiben auf Ihrem Endgerät, bis
                    Sie sie löschen.
                </p>
                <p>
                    Die Speicherung von “WordPress Stats”-Cookies erfolgt auf
                    Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der
                    Websitebetreiber hat ein berechtigtes Interesse an der
                    anonymisierten Analyse des Nutzerverhaltens, um sowohl sein
                    Webangebot als auch seine Werbung zu optimieren.
                </p>
                <p>
                    Sie können Ihren Browser so einstellen, dass Sie über das
                    Setzen von Cookies informiert werden und Cookies nur im
                    Einzelfall erlauben, die Annahme von Cookies für bestimmte
                    Fälle oder generell ausschließen sowie das automatische
                    Löschen der Cookies beim Schließen des Browser aktivieren.
                    Bei der Deaktivierung von Cookies kann die Funktionalität
                    unserer Website eingeschränkt sein.
                </p>
                <p>
                    Sie können der Erhebung und Nutzung Ihrer Daten für die
                    Zukunft widersprechen, indem Sie mit einem Klick auf diesen
                    Link einen Opt-Out-Cookie in Ihrem Browser setzen:
                    <a href="https://www.quantcast.com/opt-out/" target="_blank"
                        >https://www.quantcast.com/opt-out/</a
                    >.
                </p>
                <p>
                    Wenn Sie die Cookies auf Ihrem Rechner löschen, müssen Sie
                    den Opt-Out-Cookie erneut setzen.
                </p>
                <h3>Google AdSense</h3>
                <p>
                    Diese Website benutzt Google AdSense, einen Dienst zum
                    Einbinden von Werbeanzeigen der Google Inc. ("Google").
                    Anbieter ist die Google Inc., 1600 Amphitheatre Parkway,
                    Mountain View, CA 94043, USA.
                </p>
                <p>
                    Google AdSense verwendet sogenannte "Cookies", Textdateien,
                    die auf Ihrem Computer gespeichert werden und die eine
                    Analyse der Benutzung der Website ermöglichen. Google
                    AdSense verwendet auch so genannte Web Beacons (unsichtbare
                    Grafiken). Durch diese Web Beacons können Informationen wie
                    der Besucherverkehr auf diesen Seiten ausgewertet werden.
                </p>
                <p>
                    Die durch Cookies und Web Beacons erzeugten Informationen
                    über die Benutzung dieser Website (einschließlich Ihrer
                    IP-Adresse) und Auslieferung von Werbeformaten werden an
                    einen Server von Google in den USA übertragen und dort
                    gespeichert. Diese Informationen können von Google an
                    Vertragspartner von Google weiter gegeben werden. Google
                    wird Ihre IP-Adresse jedoch nicht mit anderen von Ihnen
                    gespeicherten Daten zusammenführen.
                </p>
                <p>
                    Die Speicherung von AdSense-Cookies erfolgt auf Grundlage
                    von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein
                    berechtigtes Interesse an der Analyse des Nutzerverhaltens,
                    um sowohl sein Webangebot als auch seine Werbung zu
                    optimieren.
                </p>
                <p>
                    Sie können die Installation der Cookies durch eine
                    entsprechende Einstellung Ihrer Browser Software verhindern;
                    wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall
                    gegebenenfalls nicht sämtliche Funktionen dieser Website
                    voll umfänglich nutzen können. Durch die Nutzung dieser
                    Website erklären Sie sich mit der Bearbeitung der über Sie
                    erhobenen Daten durch Google in der zuvor beschriebenen Art
                    und Weise und zu dem zuvor benannten Zweck einverstanden.
                </p>
                <h3>Google Analytics Remarketing</h3>
                <p>
                    Unsere Websites nutzen die Funktionen von Google Analytics
                    Remarketing in Verbindung mit den geräteübergreifenden
                    Funktionen von Google AdWords und Google DoubleClick.
                    Anbieter ist die Google Inc., 1600 Amphitheatre Parkway,
                    Mountain View, CA 94043, USA.
                </p>
                <p>
                    Diese Funktion ermöglicht es die mit Google Analytics
                    Remarketing erstellten Werbe-Zielgruppen mit den
                    geräteübergreifenden Funktionen von Google AdWords und
                    Google DoubleClick zu verknüpfen. Auf diese Weise können
                    interessenbezogene, personalisierte Werbebotschaften, die in
                    Abhängigkeit Ihres früheren Nutzungs- und Surfverhaltens auf
                    einem Endgerät (z.B. Handy) an Sie angepasst wurden auch auf
                    einem anderen Ihrer Endgeräte (z.B. Tablet oder PC)
                    angezeigt werden.
                </p>
                <p>
                    Haben Sie eine entsprechende Einwilligung erteilt, verknüpft
                    Google zu diesem Zweck Ihren Web- und App-Browserverlauf mit
                    Ihrem Google-Konto. Auf diese Weise können auf jedem
                    Endgerät auf dem Sie sich mit Ihrem Google-Konto anmelden,
                    dieselben personalisierten Werbebotschaften geschaltet
                    werden.
                </p>
                <p>
                    Zur Unterstützung dieser Funktion erfasst Google Analytics
                    google-authentifizierte IDs der Nutzer, die vorübergehend
                    mit unseren Google-Analytics-Daten verknüpft werden, um
                    Zielgruppen für die geräteübergreifende Anzeigenwerbung zu
                    definieren und zu erstellen.
                </p>
                <p>
                    Sie können dem geräteübergreifenden Remarketing/Targeting
                    dauerhaft widersprechen, indem Sie personalisierte Werbung
                    in Ihrem Google-Konto deaktivieren; folgen Sie hierzu diesem
                    Link:
                    <a
                        href="https://www.google.com/settings/ads/onweb/"
                        target="_blank"
                        >https://www.google.com/settings/ads/onweb/</a
                    >.
                </p>
                <p>
                    Die Zusammenfassung der erfassten Daten in Ihrem
                    Google-Konto erfolgt ausschließlich auf Grundlage Ihrer
                    Einwilligung, die Sie bei Google abgeben oder widerrufen
                    können (Art. 6 Abs. 1 lit. a DSGVO). Bei
                    Datenerfassungsvorgängen, die nicht in Ihrem Google-Konto
                    zusammengeführt werden (z.B. weil Sie kein Google-Konto
                    haben oder der Zusammenführung widersprochen haben) beruht
                    die Erfassung der Daten auf Art. 6 Abs. 1 lit. f DSGVO. Das
                    berechtigte Interesse ergibt sich daraus, dass der
                    Websitebetreiber ein Interesse an der anonymisierten Analyse
                    der Websitebesucher zu Werbezwecken hat.
                </p>
                <p>
                    Weitergehende Informationen und die Datenschutzbestimmungen
                    finden Sie in der Datenschutzerklärung von Google unter:
                    <a
                        href="https://www.google.com/policies/technologies/ads/"
                        target="_blank"
                        >https://www.google.com/policies/technologies/ads/</a
                    >.
                </p>
                <h3>Google AdWords und Google Conversion-Tracking</h3>
                <p>
                    Diese Website verwendet Google AdWords. AdWords ist ein
                    Online-Werbeprogramm der Google Inc., 1600 Amphitheatre
                    Parkway, Mountain View, CA 94043, United States (“Google”).
                </p>
                <p>
                    Im Rahmen von Google AdWords nutzen wir das so genannte
                    Conversion-Tracking. Wenn Sie auf eine von Google
                    geschaltete Anzeige klicken wird ein Cookie für das
                    Conversion-Tracking gesetzt. Bei Cookies handelt es sich um
                    kleine Textdateien, die der Internet-Browser auf dem
                    Computer des Nutzers ablegt. Diese Cookies verlieren nach 30
                    Tagen ihre Gültigkeit und dienen nicht der persönlichen
                    Identifizierung der Nutzer. Besucht der Nutzer bestimmte
                    Seiten dieser Website und das Cookie ist noch nicht
                    abgelaufen, können Google und wir erkennen, dass der Nutzer
                    auf die Anzeige geklickt hat und zu dieser Seite
                    weitergeleitet wurde.
                </p>
                <p>
                    Jeder Google AdWords-Kunde erhält ein anderes Cookie. Die
                    Cookies können nicht über die Websites von AdWords-Kunden
                    nachverfolgt werden. Die mithilfe des Conversion-Cookies
                    eingeholten Informationen dienen dazu,
                    Conversion-Statistiken für AdWords-Kunden zu erstellen, die
                    sich für Conversion-Tracking entschieden haben. Die Kunden
                    erfahren die Gesamtanzahl der Nutzer, die auf ihre Anzeige
                    geklickt haben und zu einer mit einem
                    Conversion-Tracking-Tag versehenen Seite weitergeleitet
                    wurden. Sie erhalten jedoch keine Informationen, mit denen
                    sich Nutzer persönlich identifizieren lassen. Wenn Sie nicht
                    am Tracking teilnehmen möchten, können Sie dieser Nutzung
                    widersprechen, indem Sie das Cookie des Google
                    Conversion-Trackings über ihren Internet-Browser unter
                    Nutzereinstellungen leicht deaktivieren. Sie werden sodann
                    nicht in die Conversion-Tracking Statistiken aufgenommen.
                </p>
                <p>
                    Die Speicherung von “Conversion-Cookies” erfolgt auf
                    Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der
                    Websitebetreiber hat ein berechtigtes Interesse an der
                    Analyse des Nutzerverhaltens, um sowohl sein Webangebot als
                    auch seine Werbung zu optimieren.
                </p>
                <p>
                    Mehr Informationen zu Google AdWords und Google
                    Conversion-Tracking finden Sie in den
                    Datenschutzbestimmungen von Google:
                    <a
                        href="https://www.google.de/policies/privacy/"
                        target="_blank"
                        >https://www.google.de/policies/privacy/</a
                    >.
                </p>
                <p>
                    Sie können Ihren Browser so einstellen, dass Sie über das
                    Setzen von Cookies informiert werden und Cookies nur im
                    Einzelfall erlauben, die Annahme von Cookies für bestimmte
                    Fälle oder generell ausschließen sowie das automatische
                    Löschen der Cookies beim Schließen des Browser aktivieren.
                    Bei der Deaktivierung von Cookies kann die Funktionalität
                    dieser Website eingeschränkt sein.
                </p>
                <h3>Google reCAPTCHA</h3>
                <p>
                    Wir nutzen “Google reCAPTCHA” (im Folgenden “reCAPTCHA”) auf
                    unseren Websites. Anbieter ist die Google Inc., 1600
                    Amphitheatre Parkway, Mountain View, CA 94043, USA
                    (“Google”).
                </p>
                <p>
                    Mit reCAPTCHA soll überprüft werden, ob die Dateneingabe auf
                    unseren Websites (z.B. in einem Kontaktformular) durch einen
                    Menschen oder durch ein automatisiertes Programm erfolgt.
                    Hierzu analysiert reCAPTCHA das Verhalten des
                    Websitebesuchers anhand verschiedener Merkmale. Diese
                    Analyse beginnt automatisch, sobald der Websitebesucher die
                    Website betritt. Zur Analyse wertet reCAPTCHA verschiedene
                    Informationen aus (z.B. IP-Adresse, Verweildauer des
                    Websitebesuchers auf der Website oder vom Nutzer getätigte
                    Mausbewegungen). Die bei der Analyse erfassten Daten werden
                    an Google weitergeleitet.
                </p>
                <p>
                    Die reCAPTCHA-Analysen laufen vollständig im Hintergrund.
                    Websitebesucher werden nicht darauf hingewiesen, dass eine
                    Analyse stattfindet.
                </p>
                <p>
                    Die Datenverarbeitung erfolgt auf Grundlage von Art. 6 Abs.
                    1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes
                    Interesse daran, seine Webangebote vor missbräuchlicher
                    automatisierter Ausspähung und vor SPAM zu schützen.
                </p>
                <p>
                    Weitere Informationen zu Google reCAPTCHA sowie die
                    Datenschutzerklärung von Google entnehmen Sie folgenden
                    Links:
                    <a
                        href="https://www.google.com/intl/de/policies/privacy/"
                        target="_blank"
                        >https://www.google.com/intl/de/policies/privacy/</a
                    >
                    und
                    <a
                        href="https://www.google.com/recaptcha/intro/android.html"
                        target="_blank"
                        >https://www.google.com/recaptcha/intro/android.html</a
                    >.
                </p>
                <h3>Facebook Pixel</h3>
                <p>
                    Unsere Website nutzt zur Konversionsmessung das
                    Besucheraktions-Pixel von Facebook, Facebook Inc., 1601 S.
                    California Ave, Palo Alto, CA 94304, USA (“Facebook”).
                </p>
                <p>
                    So kann das Verhalten der Seitenbesucher nachverfolgt
                    werden, nachdem diese durch Klick auf eine
                    Facebook-Werbeanzeige auf die Website des Anbieters
                    weitergeleitet wurden. Dadurch können die Wirksamkeit der
                    Facebook-Werbeanzeigen für statistische und
                    Marktforschungszwecke ausgewertet werden und zukünftige
                    Werbemaßnahmen optimiert werden.
                </p>
                <p>
                    Die erhobenen Daten sind für uns als Betreiber dieser
                    Website anonym, wir können keine Rückschlüsse auf die
                    Identität der Nutzer ziehen. Die Daten werden aber von
                    Facebook gespeichert und verarbeitet, sodass eine Verbindung
                    zum jeweiligen Nutzerprofil möglich ist und Facebook die
                    Daten für eigene Werbezwecke, entsprechend der
                    <a
                        href="https://www.facebook.com/about/privacy/"
                        target="_blank"
                        >Facebook-Datenverwendungsrichtlinie</a
                    >
                    verwenden kann. Dadurch kann Facebook das Schalten von
                    Werbeanzeigen auf Seiten von Facebook sowie außerhalb von
                    Facebook ermöglichen. Diese Verwendung der Daten kann von
                    uns als Seitenbetreiber nicht beeinflusst werden.
                </p>
                <p>
                    In den Datenschutzhinweisen von Facebook finden Sie weitere
                    Hinweise zum Schutz Ihrer Privatsphäre:
                    <a
                        href="https://www.facebook.com/about/privacy/"
                        target="_blank"
                        >https://www.facebook.com/about/privacy/</a
                    >.
                </p>
                <p>
                    Sie können außerdem die Remarketing-Funktion “Custom
                    Audiences” im Bereich Einstellungen für Werbeanzeigen unter
                    <a
                        href="https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen"
                        target="_blank"
                        >https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen</a
                    >
                    deaktivieren. Dazu müssen Sie bei Facebook angemeldet sein.
                </p>
                <p>
                    Wenn Sie kein Facebook Konto besitzen, können Sie
                    nutzungsbasierte Werbung von Facebook auf der Website der
                    European Interactive Digital Advertising Alliance
                    deaktivieren:
                    <a
                        href="http://www.youronlinechoices.com/de/praferenzmanagement/"
                        target="_blank"
                        >http://www.youronlinechoices.com/de/praferenzmanagement/</a
                    >.
                </p>
                <h2>6. Newsletter</h2>
                <h3>Newsletterdaten</h3>
                <p>
                    Wenn Sie den auf der Website angebotenen Newsletter beziehen
                    möchten, benötigen wir von Ihnen eine E-Mail-Adresse sowie
                    Informationen, welche uns die Überprüfung gestatten, dass
                    Sie der Inhaber der angegebenen E-Mail-Adresse sind und mit
                    dem Empfang des Newsletters einverstanden sind. Weitere
                    Daten werden nicht bzw. nur auf freiwilliger Basis erhoben.
                    Diese Daten verwenden wir ausschließlich für den Versand der
                    angeforderten Informationen und geben diese nicht an Dritte
                    weiter.
                </p>
                <p>
                    Die Verarbeitung der in das Newsletteranmeldeformular
                    eingegebenen Daten erfolgt ausschließlich auf Grundlage
                    Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Die
                    erteilte Einwilligung zur Speicherung der Daten, der
                    E-Mail-Adresse sowie deren Nutzung zum Versand des
                    Newsletters können Sie jederzeit widerrufen, etwa über den
                    "Austragen"-Link im Newsletter. Die Rechtmäßigkeit der
                    bereits erfolgten Datenverarbeitungsvorgänge bleibt vom
                    Widerruf unberührt.
                </p>
                <p>
                    Die von Ihnen zum Zwecke des Newsletter-Bezugs bei uns
                    hinterlegten Daten werden von uns bis zu Ihrer Austragung
                    aus dem Newsletter gespeichert und nach der Abbestellung des
                    Newsletters gelöscht. Daten, die zu anderen Zwecken bei uns
                    gespeichert wurden (z.B. E-Mail-Adressen für den
                    Mitgliederbereich) bleiben hiervon unberührt.
                </p>
                <h2>7. Plugins und Tools</h2>
                <h3>YouTube</h3>
                <p>
                    Unsere Website nutzt Plugins der von Google betriebenen
                    Seite YouTube. Betreiber der Seiten ist die YouTube, LLC,
                    901 Cherry Ave., San Bruno, CA 94066, USA.
                </p>
                <p>
                    Wenn Sie eine unserer mit einem YouTube-Plugin
                    ausgestatteten Seiten besuchen, wird eine Verbindung zu den
                    Servern von YouTube hergestellt. Dabei wird dem
                    YouTube-Server mitgeteilt, welche unserer Seiten Sie besucht
                    haben.
                </p>
                <p>
                    Wenn Sie in Ihrem YouTube-Account eingeloggt sind,
                    ermöglichen Sie YouTube, Ihr Surfverhalten direkt Ihrem
                    persönlichen Profil zuzuordnen. Dies können Sie verhindern,
                    indem Sie sich aus Ihrem YouTube-Account ausloggen.
                </p>
                <p>
                    Die Nutzung von YouTube erfolgt im Interesse einer
                    ansprechenden Darstellung unserer Online-Angebote. Dies
                    stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1
                    lit. f DSGVO dar.
                </p>
                <p>
                    Weitere Informationen zum Umgang mit Nutzerdaten finden Sie
                    in der Datenschutzerklärung von YouTube unter:
                    <a
                        href="https://www.google.de/intl/de/policies/privacy"
                        target="_blank"
                        >https://www.google.de/intl/de/policies/privacy</a
                    >.
                </p>
                <h3>Vimeo</h3>
                <p>
                    Unsere Website nutzt Plugins des Videoportals Vimeo.
                    Anbieter ist die Vimeo Inc., 555 West 18th Street, New York,
                    New York 10011, USA.
                </p>
                <p>
                    Wenn Sie eine unserer mit einem Vimeo-Plugin ausgestatteten
                    Seiten besuchen, wird eine Verbindung zu den Servern von
                    Vimeo hergestellt. Dabei wird dem Vimeo-Server mitgeteilt,
                    welche unserer Seiten Sie besucht haben. Zudem erlangt Vimeo
                    Ihre IP-Adresse. Dies gilt auch dann, wenn Sie nicht bei
                    Vimeo eingeloggt sind oder keinen Account bei Vimeo
                    besitzen. Die von Vimeo erfassten Informationen werden an
                    den Vimeo-Server in den USA übermittelt.
                </p>
                <p>
                    Wenn Sie in Ihrem Vimeo-Account eingeloggt sind, ermöglichen
                    Sie Vimeo, Ihr Surfverhalten direkt Ihrem persönlichen
                    Profil zuzuordnen. Dies können Sie verhindern, indem Sie
                    sich aus Ihrem Vimeo-Account ausloggen.
                </p>
                <p>
                    Weitere Informationen zum Umgang mit Nutzerdaten finden Sie
                    in der Datenschutzerklärung von Vimeo unter:
                    <a href="https://vimeo.com/privacy" target="_blank"
                        >https://vimeo.com/privacy</a
                    >.
                </p>
                <h3>Google Web Fonts</h3>
                <p>
                    Diese Seite nutzt zur einheitlichen Darstellung von
                    Schriftarten so genannte Web Fonts, die von Google
                    bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr
                    Browser die benötigten Web Fonts in ihren Browsercache, um
                    Texte und Schriftarten korrekt anzuzeigen.
                </p>
                <p>
                    Zu diesem Zweck muss der von Ihnen verwendete Browser
                    Verbindung zu den Servern von Google aufnehmen. Hierdurch
                    erlangt Google Kenntnis darüber, dass über Ihre IP-Adresse
                    unsere Website aufgerufen wurde. Die Nutzung von Google Web
                    Fonts erfolgt im Interesse einer einheitlichen und
                    ansprechenden Darstellung unserer Online-Angebote. Dies
                    stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1
                    lit. f DSGVO dar.
                </p>
                <p>
                    Wenn Ihr Browser Web Fonts nicht unterstützt, wird eine
                    Standardschrift von Ihrem Computer genutzt.
                </p>
                <p>
                    Weitere Informationen zu Google Web Fonts finden Sie unter
                    <a
                        href="https://developers.google.com/fonts/faq"
                        target="_blank"
                        >https://developers.google.com/fonts/faq</a
                    >
                    und in der Datenschutzerklärung von Google:
                    <a
                        href="https://www.google.com/policies/privacy/"
                        target="_blank"
                        >https://www.google.com/policies/privacy/</a
                    >.
                </p>
                <h3>Google Maps</h3>
                <p>
                    Diese Seite nutzt über eine API den Kartendienst Google
                    Maps. Anbieter ist die Google Inc., 1600 Amphitheatre
                    Parkway, Mountain View, CA 94043, USA.
                </p>
                <p>
                    Zur Nutzung der Funktionen von Google Maps ist es notwendig,
                    Ihre IP Adresse zu speichern. Diese Informationen werden in
                    der Regel an einen Server von Google in den USA übertragen
                    und dort gespeichert. Der Anbieter dieser Seite hat keinen
                    Einfluss auf diese Datenübertragung.
                </p>
                <p>
                    Die Nutzung von Google Maps erfolgt im Interesse einer
                    ansprechenden Darstellung unserer Online-Angebote und an
                    einer leichten Auffindbarkeit der von uns auf der Website
                    angegebenen Orte. Dies stellt ein berechtigtes Interesse im
                    Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.
                </p>
                <p>
                    Mehr Informationen zum Umgang mit Nutzerdaten finden Sie in
                    der Datenschutzerklärung von Google:
                    <a
                        href="https://www.google.de/intl/de/policies/privacy/"
                        target="_blank"
                        >https://www.google.de/intl/de/policies/privacy/</a
                    >.
                </p>
                <h2>8. Zahlungsanbieter</h2>
                <h3>PayPal</h3>
                <p>
                    Auf unserer Website bieten wir u.a. die Bezahlung via PayPal
                    an. Anbieter dieses Zahlungsdienstes ist die PayPal (Europe)
                    S.à.r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449
                    Luxembourg (im Folgenden “PayPal”).
                </p>
                <p>
                    Wenn Sie die Bezahlung via PayPal auswählen, werden die von
                    Ihnen eingegebenen Zahlungsdaten an PayPal übermittelt.
                </p>
                <p>
                    Die Übermittlung Ihrer Daten an PayPal erfolgt auf Grundlage
                    von Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) und Art. 6
                    Abs. 1 lit. b DSGVO (Verarbeitung zur Erfüllung eines
                    Vertrags). Sie haben die Möglichkeit, Ihre Einwilligung zur
                    Datenverarbeitung jederzeit zu widerrufen. Ein Widerruf
                    wirkt sich auf die Wirksamkeit von in der Vergangenheit
                    liegenden Datenverarbeitungsvorgängen nicht aus.
                </p>

                <hr class="m-divider my-6" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
useSeoMeta({
    title: "Datenschutzerklärung | Moebix",
    description:
        "Datenschutzerklärung von Moebix.de — Informationen zu Verarbeitung personenbezogener Daten gemäß DSGVO.",
    ogTitle: "Datenschutzerklärung — Moebix.de",
    ogDescription:
        "Datenschutzerklärung von Moebix.de — Informationen zu Verarbeitung personenbezogener Daten gemäß DSGVO.",
    ogType: "website",
    ogImage: "/moebix_og_sticker.jpg",
    ogUrl: "https://www.moebix.de/datenschutz",
});

useHead({
    link: [{ rel: "canonical", href: "https://www.moebix.de/datenschutz" }],
});
</script>

<style scoped>
.legal-content :deep(h2) {
    font-size: 1.25rem;
    font-weight: 700;
    margin-top: 2rem;
    margin-bottom: 0.75rem;
}
.legal-content :deep(h3) {
    font-size: 1rem;
    font-weight: 700;
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
}
.legal-content :deep(p) {
    margin-bottom: 0.75rem;
    line-height: 1.7;
    font-size: 0.9375rem;
    color: rgba(0, 0, 0, 0.75);
}
.legal-content :deep(ul) {
    margin-bottom: 0.75rem;
    padding-left: 1.5rem;
}
.legal-content :deep(a) {
    color: #3c8f93;
    word-break: break-all;
}
</style>
